import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { Popup, Icon } from 'semantic-ui-react'
import { Link } from 'react-router-dom'
import styles from './VideoHeaderStyles'

class VideoHeader extends PureComponent {
  static defaultProps = {
    videoTitle: ''
  }

  static propTypes = {
    videoTitle: PropTypes.string.isRequired,
    activeProject: PropTypes.object
  }

  getGoBackLinkUrl = () => {
    return this.props.activeProject && this.props.activeProject.id ?
        `/projects/${this.props.activeProject.id}` : '/projects'
  }

  render() {
    return (
      <div className={styles.wrapper}>
        <div></div>
        <p>{this.props.videoTitle}</p>
        <Popup
          content='Go Back' size='mini' inverted
          position="right center"
          trigger={
            <Link className={styles.button} to={this.getGoBackLinkUrl()}>
              <Icon name='arrow alternate circle left outline' size="large"/>
            </Link>
          }
        />
      </div>
    )
  }
}

export default VideoHeader



// WEBPACK FOOTER //
// ./src/Components/VideoPlayer/VideoHeader/VideoHeader.js